export function slider(ctx) {
    return {
        styles: {
            main:      { ...ctx.pretty, radius: 999, border_width: 0 },
            // indicator = pretty_color
            indicator: { bg_color: ctx.indic, radius: 999 },
            // knob = slider_knob
            knob:      { bg_color: '#808080', border_color: ctx.BORDER },
        },
    };
}
